import { render, staticRenderFns } from "./Asset-Detail.vue?vue&type=template&id=20643710&"
import script from "./Asset-Detail.vue?vue&type=script&lang=ts&"
export * from "./Asset-Detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports